const paymentSetupError = (message, code, status = null) => {
  const error = new Error(message);
  error.code = code;
  error.status = status;
  error.userMessage = message;
  return error;
};

export const setupSubscriptionPayment = async ({
  priceId,
  getToken = () => localStorage.getItem('adminToken'),
  fetchImpl = fetch,
}) => {
  const token = getToken();
  if (!token) {
    throw paymentSetupError('Please sign in again to continue.', 'missing_auth');
  }

  let response;
  try {
    response = await fetchImpl('/api/billing/setup', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        price_id: priceId,
        plan: 'home_cook',
      }),
    });
  } catch {
    throw paymentSetupError(
      "We couldn't reach secure payment setup. Please try again.",
      'network_error',
    );
  }

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    // A non-JSON response should still become a safe, actionable error below.
  }

  if (!response.ok) {
    throw paymentSetupError(
      payload.detail || 'Could not set up payment. Please try again.',
      'setup_rejected',
      response.status,
    );
  }

  if (!payload.client_secret) {
    throw paymentSetupError(
      'Could not set up payment. Please try again.',
      'invalid_response',
      response.status,
    );
  }

  return payload;
};